'use strict';

angular.module('error')
.component('helpInvalidError', {
    transclude: true,
    templateUrl: 'modules/error/components/help-invalid-error/content.html',
    controller: 'HelpInvalidErrorController',
    bindings: {},
});
